import React, { useState } from "react";
import api from "./api";

export default function RepertorySearch() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
const [expandedId, setExpandedId] = useState(null);
const [rubricDetails, setRubricDetails] = useState({});
const [openChildren, setOpenChildren] = useState({});
const toggleChild = (childId) => {

  setOpenChildren(prev => ({
    ...prev,
    [childId]: !prev[childId]
  }));

};
 const loadRubric = async (id) => {

  if(expandedId === id){
    setExpandedId(null);
    return;
  }

  const res = await api.get(
    `/api/repertory/rubric/${id}`
  );

  setRubricDetails(prev => ({
    ...prev,
    [id]: res.data
  }));

  setExpandedId(id);
};
 const handleSearch = async () => {
  if (!query.trim()) return;
  try {
    const res = await api.get(
      `/api/repertory/search?q=${query}`
    );
    setResults(res.data);
  } catch(err) {
    console.error(err);
  }
};
  return (
    <div style={{ padding: "20px" }}>

      <h2>Repertory Search</h2>

      {/* 🔍 Search Box */}
      <input
        type="text"
        placeholder="Enter keyword (e.g., absent,morning)"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{ padding: "10px", width: "300px" }}
      />

      <button onClick={handleSearch} style={{ marginLeft: "10px" }}>
        Search
      </button>

      {loading && <p>Loading...</p>}

      {/* 📊 RESULTS */}
     {results.map((item) => (

  <div key={item.id}>

    <div
      onClick={() => loadRubric(item.id)}
      style={{
        border:"1px solid #ccc",
        padding:"10px",
        marginBottom:"5px",
        cursor:"pointer",
        background:"#fff"
      }}
    >
      <div>
        <b>[{item.lesson}]</b>
      </div>
      <div>
        {item.path}
      </div>
    </div>
    {expandedId === item.id &&
      rubricDetails[item.id] && (
      <div
        style={{
          marginLeft:"20px",
          marginBottom:"15px",
          padding:"15px",
          background:"#f8f9fa",
          border:"1px solid #ddd"
        }}
      >

        <h5>
          {rubricDetails[item.id].name}
        </h5>

        <div
          style={{
            display:"flex",
            flexWrap:"wrap",
            gap:"8px"
          }}
        >
          {rubricDetails[item.id].remedies?.map(
            (r,index) => (

            <span
              key={index}
              style={{
                background:"#28a745",
                color:"#fff",
                padding:"5px 10px",
                borderRadius:"15px"
              }}
            >
              {r.weight}: {r.name}
            </span>

          ))}
        </div>

        {rubricDetails[item.id].children?.length > 0 && (

          <div style={{marginTop:"15px"}}>

            <h6>Sub Rubrics</h6>

            {rubricDetails[item.id].children.map(
              child => (

              <div
                key={child.id}
                style={{
                  marginBottom:"10px",
                  padding:"10px",
                  border:"1px solid #eee"
                }}
              >
  <div key={child.id}
    style={{
      marginBottom:"10px",
      border:"1px solid #eee",
      borderRadius:"5px"
         }}>
  <div
    onClick={
      () => toggleChild(child.id)
            }
    style={{
      padding:"10px",
      cursor:"pointer",
      background:"#f5f5f5",
      fontWeight:"bold",
      display:"flex",
      justifyContent:"space-between"
    }}
  >
  <span>
  {child.name}
  </span>
  <span>
      {openChildren[child.id] ? "▲" : "▼"}
  </span>
  </div>
  {openChildren[child.id] && (
  <div
      style={{
        padding:"10px"
      }}
  >
      {child.remedies.map(
        (r,index) => (

        <span
          key={index}
          style={{
            background:"#17a2b8",
            color:"#fff",
            padding:"5px 10px",
            borderRadius:"15px",
            marginRight:"5px",
            marginBottom:"5px",
            display:"inline-block"
          }}
        >
          {r.weight}: {r.name}
        </span>

    ))}
    </div>
  )}
</div>
 </div>
            ))}
          </div>
        )}
      </div>
    )}
  </div>
))}
    </div>
  );
}
function RubricNode({ rubric }) {

  return (
    <div
      style={{
        marginLeft: "20px",
        borderLeft: "2px solid #ddd",
        paddingLeft: "10px",
        marginTop: "10px"
      }}
    >

      <h5>{rubric.name}</h5>

      {rubric.notes && (
        <p>{rubric.notes}</p>
      )}

      {rubric.remedies?.length > 0 && (

        <div style={{ marginBottom: "10px" }}>

          <b>Remedies:</b>{" "}

          {rubric.remedies.map((r, index) => (

            <span
              key={index}
              style={{
                background: "#28a745",
                color: "white",
                padding: "4px 8px",
                borderRadius: "10px",
                marginRight: "5px"
              }}
            >
              {r.name}
              <sup>{r.weight}</sup>
            </span>

          ))}

        </div>

      )}

      {rubric.children?.map((child) => (

        <RubricNode
          key={child.id}
          rubric={child}
        />
      ))}
    </div>
  );
}